import { InstrumentModel } from '@javascript/habitual-analytics/models/instrument/types';
import { HHMMSString, YYYYMMDDString } from './datetime';

export type MarketDatum = {
  ltp: number,
  oi: number,
  firstOpen: number,
  prevDayLtp: number,
  prevDayOi: number,
  firstOi: number,
};

export type MarketData = Record<string, MarketDatum>;

export type Ticks = {
  date: YYYYMMDDString;
  time: HHMMSString;
  marketData: MarketData;
};

export enum ChangeFromType {
  PrevDayLtp = 'prevDayLtp',
  FirstOi = 'firstOi',
};

export enum OptionTypes {
  CE = 'CE',
  PE = 'PE'
}

export enum TransactionTypes {
  BUY = 'buy',
  SELL = 'sell',
}

export type Leg = {
  strikePrice: number;
  optionType: OptionTypes.CE | OptionTypes.PE;
  price: number;
  legExpiry: YYYYMMDDString;
  transactionType: TransactionTypes.BUY | TransactionTypes.SELL;
  lot: number;
  strikeIndex: number;
  strikeLabel: string;
  tradingSymbolObj: InstrumentModel;
  ltpDisplayFormat: string;
};
